import * as React from "react";
import type { SVGProps } from "react";
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12m1.5 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12m-12.842 5.32c0 .375.305.68.681.68h.074a.68.68 0 0 0 0-1.362h-.074a.68.68 0 0 0-.68.681m.738-2.3c.323 0 .57-.263.6-.585q.008-.084.023-.168.031-.194.112-.38.15-.335.394-.61.254-.273.563-.504l.648-.468q.337-.24.647-.513.319-.274.563-.628a3 3 0 0 0 .404-.813q.15-.46.15-1.07v-.168q0-.646-.263-1.212a3.1 3.1 0 0 0-.703-.99q-.45-.425-1.051-.663A3.3 3.3 0 0 0 12.697 6h-.385a3.4 3.4 0 0 0-1.295.248q-.6.239-1.05.663t-.714.99c-.163.366-.221.739-.242 1.12a.585.585 0 0 0 .594.604c.334 0 .592-.271.613-.605.016-.236.056-.47.161-.694q.17-.372.46-.646.3-.274.685-.433.394-.16.845-.16h.262q.45 0 .835.16.395.159.686.433.3.274.469.646.168.362.168.787v.168q0 .504-.15.875-.15.372-.403.663-.244.293-.563.53-.31.24-.648.478a12 12 0 0 0-.647.487 3.7 3.7 0 0 0-.563.583 2.8 2.8 0 0 0-.394.76 2.6 2.6 0 0 0-.137.737c-.023.345.267.626.612.626"
      clipRule="evenodd"
    />
  </svg>
);
export default Icon;
